import $ from 'jquery';

export default () => {
  $('.page-content table, .call-to-action-accordion-content table, section.wysiwyg-widget table').each(function(){
    $(this).wrap('<div class="table-overflow"></div>');
  })
}